import { Error } from "@mui/icons-material";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  billingApi,
  BillingProfile,
  BillingProfilePayload,
} from "services/billingApi";

const BILLING_PROFILE_QUERY_KEY = ["billing", "profile"];

export const useBillingProfile = () =>
  useQuery<BillingProfile | null>({
    queryKey: BILLING_PROFILE_QUERY_KEY,
    queryFn: () => billingApi.getBillingProfile(),
    staleTime: 5 * 60 * 1000,
  });

export const useUpsertBillingProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: BillingProfilePayload) =>
      billingApi.upsertBillingProfile(payload),
    onSuccess: (data) => {
      queryClient.setQueryData(BILLING_PROFILE_QUERY_KEY, data);
    },
    onError: (error) => {},
  });
};
